import React, { useEffect, useState, useContext } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
// import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, collection, query, where, getDocs, updateDoc, collectionGroup } from "firebase/firestore"
import {  Link, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import Switch from '@mui/material/Switch';
import img from '../../../assets/images/user.png'
import ConfirmStatusBox from '../../../components/ConfirmStatusBox'
import ConfirmBox from '../../../components/ConfirmBox';

import outlet from '../../../assets/images/outlet-2.png'

import { AuthContext } from '../../../context/AuthContext'




const Single = ({user}) => {

  const {eventId} = useParams()


  const [ eventData, setEventData ] = useState([])

  const [ userData, setUserData ] = useState([])

  const [photos, setPhotos] = useState([])
 
  const [ openModal, setOpenModal ] = useState(false)

  const closeModal = () => setOpenModal(false)

  const [openStatus, setOpenStatus] = useState(false)

  const [adminRole, setAdminRole] = useState("")

  const { currentUser } = useContext(AuthContext)

  const userIds = currentUser.uid;  


  
  
        
  const getAdminRole = async() => {
    
    const docRef = doc(db, "admins", userIds);

    const docSnap = await getDoc(docRef);

    
    if (docSnap.exists()) {

      setAdminRole(docSnap.data().role)

    } else {

      console.log("No such document!");
    }
  }


  useEffect(()=>  {

    getAdminRole()

  }, [])





  const getSingleDocumentById = async() => {

  const subcollectionGroup = collectionGroup(db, 'outletEvent');

  // 2. Filter using FieldPath.documentId()
  const singleDocQuery = query(

    subcollectionGroup, 

    where('eventId', '==', eventId) 

  );

  // 3. Execute the query
  const querySnapshot = await getDocs(singleDocQuery);

  // 4. Handle and display the single document
  if (!querySnapshot.empty) {

    const doc = querySnapshot.docs[0];

    console.log("Document Data:", doc.data());

    setEventData(doc.data())

    console.log("Full Document Path:", doc.ref.path);

  } else {

    console.log("No matching document found.");

  }


}


useEffect(() => {

  getSingleDocumentById()

}, [])





//  useEffect(() => {
//     // Define the group query targeting the subcollection name
//     const q = query(
//       collectionGroup(db, "outletEvent"), // Name of your subcollection
//       where('eventId', '==', eventId) // Filter by the ID saved inside the doc
//     );

//     const unsubscribe = onSnapshot(q, (snapshot) => {
//       const docsData = [];
//       snapshot.forEach((doc) => {
//         docsData.push({
//           id: doc.id,
//           ...doc.data(),
//           // ref: doc.ref // Save the absolute document reference for updates
//         });
//       });
//       setEventData(docsData);
//       // setLoading(false);
//     }, (error) => {
//       console.error("Snapshot error:", error);
//       // setLoading(false);
//     });

//     // Clean up listener on unmount
//     return () => unsubscribe();
//   }, []);



 
 
 
  const getOutlet = async() => {

      const docRef = doc(db, "subscribers", eventId);

      const docSnap = await getDoc(docRef);

    
      
      if (docSnap.exists()) {

        setEventData(docSnap.data())
        // setAccountUser(true)
        setPhotos(docSnap.data().files)
        // console.log(eventData)
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
  }

  useEffect(()=>{

    getOutlet()

  }, [])


  //  useEffect(() => {
    
  //   //LISTEN REAL TIME

  //   const reviewQuery = async() => {

  //     const reviewRef = (collection(db, "reviews"));
  //     const q = query(reviewRef, where("subId", "==", eventId));

  //     const querySnapshot = await getDocs(q);
  //       let list = []
  //     querySnapshot.forEach((doc) => {
  //       // doc.data() is never undefined for query doc snapshots
  //       list.push(doc.data())
  //       // console.log(doc.id, " => ", doc.data());
  //       console.log(list)

  //       setReview(list)
  //       // console.log(orderData)
  //     });

  //   }
    
  //   reviewQuery()   

  // },[])





const handleModal = (photo) => {

  setOpenModal(true) 
  setPhotos(photo)

}


  const options = {  maximumFractionDigits: 2 }


  const Modal = ({open, close, photo}) => {
     
    if(!open) return null
    return(
     <div style={{
      backgroundColor: 'black',
      widows:'100%',
      height:'100%',
     }}>
       <div style={{

        maxWidth: 600,
        backgroundColor: 'white',
      }}>
       
         <div className="modalRight">
           <p className="closeBtn" onClick={close}>X</p>
           <div></div>

 
         </div>
       </div>
     </div>
    )
}


  const handleStatus = async() => {

    const eventRef = doc(db, "subscribers", eventData.subId, "outletEvent", eventId);

    await updateDoc(eventRef, {

    status: eventData.status === "active" ? 'inactive' : 'active', 

  })

  setOpenStatus(false)

}
 

  return (
    <div className='single'>
      <Modal open={openModal} close={closeModal} />
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <div style={{display: 'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Outlet Event Information</h2>

            {

              adminRole === "adminAccess"

              ?

            <div style={{display:'flex', flexDirection:'row', gap:10, justifyContent:'center', alignItems:'center', marginRight:100 }}>
                <a onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:eventData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>{eventData.status === "active" ? "Active" : "Inactive"}</span>
                </a>
{/* 
                 <Link to={`/paid/edit/${eventId}`} style={{ border: '1px solid blue', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"blue", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>Edit</span>
                </Link> */}

           

            </div>

              :

              adminRole === "subadminAccess"

              ?

              <div style={{display:'flex', flexDirection:'row', gap:10, justifyContent:'center', alignItems:'center', marginRight:100 }}>
                <a onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:eventData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>{eventData.status === "active" ? "Active" : "Inactive"}</span>
                </a>

                 <Link to={`/paid/edit/${eventId}`} style={{ border: '1px solid blue', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"blue", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>Edit</span>
                </Link>

           

              </div>


            :

            ""


            }

            </div>
            <div className='item'>
              
              {/* <div style={{width:'200px', height:'200px', alignItems:'center', justifyContent:'center'}}>

                  <img
                      src = {outlet}
                      alt="avatar"
                      style={{width:'100px', height:'100px', }}
                        
                  /> 

              </div> */}
          
              
                <div className="details">
                
                  <div className='detailItem'>
                    <span className='itemKey'>Event Title:</span>
                    <span className='itemValue'>{eventData.title}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Event Category:</span>
                    <span className='itemValue'>{eventData.category}</span>
                  </div>
                   <div className='detailItem'>
                    <span className='itemKey'>Event Description:</span>
                    <span className='itemValue'>{eventData.description}</span>
                  </div>
                    <div className='detailItem'>
                    <span className='itemKey'>Event Venue:</span>
                    <span className='itemValue'>{eventData.eventoutletname} {eventData.eventoutlet}</span>
                  </div>
                      <div className='detailItem'>
                    <span className='itemKey'>Event Address:</span>
                    <span className='itemValue'>{eventData.eventaddress}</span>
                  </div>
                   <div className='detailItem'>
                    <span className='itemKey'>Event Area:</span>
                    <span className='itemValue'>{eventData.eventarea}</span>
                  </div>
                   <div className='detailItem'>
                    <span className='itemKey'>Event City:</span>
                    <span className='itemValue'>{eventData.eventregion}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Event Date:</span>
                    <span className='itemValue'>{eventData.eventDate}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Event Time:</span>
                    <span className='itemValue'>{eventData.eventTime}</span>
                  </div>
               
                </div>



            </div>
          </div>
       
        </div>
       
        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Event Photos</h2>
            <div style={{display:'flex', flexDirection:'row', gap:30, flexWrap:'wrap', justifyContent:'center', alignItems:'center', marginLeft:20, marginRight:20, marginBottom:20}}>

                  <img
                      src = {eventData.outletImage}
                      alt="avatar"
                      style={{width:'100%', height: '100%', }}
                        
                  /> 

            </div>
          </div>
        
        </div>


        <ConfirmStatusBox
          openStatus={openStatus}
          closeDialog={() => setOpenStatus(false)}
          statusFunction={handleStatus }
        />



      </div>
    </div>
  )
}

export default Single